export * from './saved-tour-filters.component';
export * from './saved-tour-filters.component.module';